import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { IconFieldProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid } from "@mui/material";

//#endregion
import cssExports from "theme/styles/main.module.scss";
import { TimeReportingEnums } from "models/enums";

const IconField: React.FC<IconFieldProps> = (props) => {
  return (
    <Grid container alignItems={"center"} justifyContent={"center"} item className={cssExports.iconField}>
      <Icon
        icon={
          props.value === TimeReportingEnums.TimeReportType.project
            ? IconDefinitionConstants.WFolder
            : props.value === TimeReportingEnums.TimeReportType.deviation
            ? IconDefinitionConstants.WCalendarTime
            : IconDefinitionConstants.WCalendar
        }
      />
    </Grid>
  );
};

export default IconField;
